import { Component, OnInit } from '@angular/core';
import { PortalDataElementListIndicatorElementComponent } from '../portal-data-element-list-indicator-element/portal-data-element-list-indicator-element.component';
import { CommonModule } from '@angular/common';
import { PortalDataDashboardGlobalIndicatorService } from '../../services/portal-data-dashboard-global-indicator.service';
import { PortalDataDashboardGlobalIndicatorModel } from '../../models/portal-data-dashboard-global-indicator.model';
import { PortalDataElementListIndicatorElementContainerComponent } from '../portal-data-element-list-indicator-element-container/portal-data-element-list-indicator-element-container.component';

@Component({
  selector: 'app-portal-data-dashboard-global-indicator-bar',
  standalone: true,
  imports: [
    PortalDataElementListIndicatorElementComponent,
    CommonModule,
    PortalDataElementListIndicatorElementContainerComponent,
  ],
  templateUrl: './portal-data-dashboard-global-indicator-bar.component.html',
  styleUrl: './portal-data-dashboard-global-indicator-bar.component.scss',
})
export class PortalDataDashboardGlobalIndicatorBarComponent implements OnInit {
  portalDataDashboardGlobalIndicatorData:
    | PortalDataDashboardGlobalIndicatorModel
    | undefined;

  constructor(
    private portalDataDashboardGlobalIndicatorService: PortalDataDashboardGlobalIndicatorService
  ) {}

  ngOnInit() {
    this.portalDataDashboardGlobalIndicatorService.data$.subscribe(response => {
      this.portalDataDashboardGlobalIndicatorData = response;
    });

    this.portalDataDashboardGlobalIndicatorService
      .getList()
      .subscribe(response => {
        this.portalDataDashboardGlobalIndicatorData = response;
      });
  }
}
